export default "__VITE_ASSET__78f1c2a3__"